export const borders = {}
